import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";
import * as VueMenu from "@hscmap/vue-menu";
Vue.use(VueMenu);
Vue.use(Vuetify, {
  iconfont: "md"
});
